import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import moment from "moment";
import reportService from "./reports-service";
import exportLimit from "../../common/export-limit.vue";

export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      refresh: true,
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date(new Date().getTime() - 86400000).toISOString().split("T")[0],
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      sDate: "",
      eDate: "",
      showStartDate: true,
      showEndDate: true,
      startDate: false,
      endDate: false,
      selectedProject: "",
      projectList: [],
      selectedBusiness: "",
      businessData: [],
      selectedClass: "",
      classData: [],
      selectedOEM: "",
      OEMData: [],
      selectedWarehouse: "",
      warehouseData: [],
      selectedPOLineType: "",
      poLineTypeData: [],
      selectedStatus: "",
      statusData: [],
      selectedRouteSubType: "",
      routeSubTypeData: [],
      selectedLocation: "",
      locationData: [],
      dateSelected: false,
      runDisabled: true,
      page: 1,
      totalPages: 0,
      showBusiness: false,
      showClass: false,
      showOEM: false,
      showWarehouse: false,
      showPOLineType: false,
      showStatus: false,
      showRouteSubType: false,
      showLocation: false,
      poStatusData: [],
      excelName: "",
      totalRecords: 0,
      exportDisable: true,
      export50kData: false,
      exportDialog: false,
      showData: false,
      headerPOStatus: [
        {
          text: "Project",
          value: "Project",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Business",
          value: "Business",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "PO_Number",
          value: "PO_Number",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Line_no",
          value: "Line_no",
          class: "primary customwhite--text",
          width: "5%",
        },
        {
          text:"Order_Type",
          value:"Order_Type",
          class: "primary customwhite--text",
          width: "6%",
        },
        {
          text: "RMA",
          value: "RMA",
          class: "primary customwhite--text",
          width: "6%",
        },
        {
          text: "Item",
          value: "Item",
          class: "primary customwhite--text",
          width: "6%",
        },
        {
          text: "Model",
          value: "Model",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Class",
          value: "Class",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "OEM",
          value: "OEM",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Order_Date",
          value: "Order_Date",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Req_date",
          value: "Req_date",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Ord_Qty",
          value: "Ord_Qty",
          class: "primary customwhite--text",
          width: "5%",
        },
        {
          text: "Rcvd_Qty",
          value: "Rcvd_Qty",
          class: "primary customwhite--text",
          width: "5%",
        },
        {
          text: "Shpd_Qty",
          value: "Shpd_Qty",
          class: "primary customwhite--text",
          width: "5%",
        },
        {
          text: "Open_Qty",
          value: "Open_Qty",
          class: "primary customwhite--text",
          width: "5%",
        },
        {
          text: "Pending Packslip",
          value: "Pending_Packslip",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Location",
          value: "Location",
          class: "primary customwhite--text",
          width: "6%",
        },
        // {
        //   text: "Order No",
        //   value: "Order_no",
        //   class: "primary customwhite--text",
        //   width: "7%",
        // },
        // {
        //   text: "Vendor ID",
        //   value: "Vendor_id",
        //   class: "primary customwhite--text",
        //   width: "7%",
        // },
        // {
        //   text: "Vendor Name",
        //   value: "Vendor_Name",
        //   class: "primary customwhite--text",
        //   width: "12%",
        // },
        // {
        //   text: "Carrier",
        //   value: "Carrier",
        //   class: "primary customwhite--text",
        //   width: "8%",
        // },
        // {
        //   text: "Description",
        //   value: "Description",
        //   class: "primary customwhite--text",
        //   width: "15%",
        // },
        // {
        //   text: "Cost",
        //   value: "Cost",
        //   class: "primary customwhite--text",
        //   width: "6%",
        // }, 
        // {
        //   text: "Rcvd Qty",
        //   value: "Rcvd_Qty",
        //   class: "primary customwhite--text",
        //   width: "5%",
        // },
        // {
        //   text: "Warehouse",
        //   value: "Warehouse",
        //   class: "primary customwhite--text",
        //   width: "8%",
        // },
      ],
      json_fields: {
        Project: "Project",
        Business: "Business",
        "PO_Number": "PO_Number",
        "Line_no": "Line_no",
        "Order_Type": "Order_Type",
        RMA: "RMA",
        "Vend_SO": "Vend_SO",
        "Order_no": "Order_no",
        "Cust_PO_Type": "Cust_PO_Type",
        "Vendor_id": "Vendor_id",
        "Vendor_Name": "Vendor_Name",
        "Addr1": "Addr1",
        "Addr2": "Addr2",
        City: "City",
        State: "State",
        "ZipCode": "ZipCode",
        Carrier: "Carrier",
        Item: "Item",
        Description: "Description",
        Model: "Model",
        Class: "Class",
        OEM: "OEM",
        Cost: "Cost",
        "Order_Date": "Order_Date",
        "Req_date": "Req_date",
        "Ord_Qty": "Ord_Qty",
        "Rcvd_Qty": "Rcvd_Qty",
        "Shpd_Qty": "Shpd_Qty",
        "Open_Qty": "Open_Qty",
        "Pending Packslip": "Pending_Packslip",
        Location: "Location",
        Warehouse: "Warehouse",
        Comment: "Comment",
      },
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.sDate
        ? moment(this.sDate).format("MM/DD/YYYY")
        : moment(new Date().getTime() - 86400000).format("MM/DD/YYYY");
    },
    computedEndDateFormattedMomentjs() {
      return this.eDate
        ? moment(this.eDate).format("MM/DD/YYYY")
        : moment(new Date()).format("MM/DD/YYYY");
    },
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.showStartDate = false;
      this.showEndDate = false;
      this.$nextTick(() => {
        this.showStartDate = true;
        this.sDate = null;
        this.showEndDate = true;
        this.eDate = null;
      });
      this.selectedProject = "";
      this.projectList = [];
      this.selectedBusiness = "";
      this.businessData = [];
      this.selectedClass = "";
      this.classData = [];
      this.selectedOEM = "";
      this.OEMData = [];
      this.selectedWarehouse = "";
      this.warehouseData = [];
      this.selectedPOLineType = "";
      this.poLineTypeData = [];
      this.selectedStatus = "";
      this.statusData = [];
      this.selectedRouteSubType = "";
      this.routeSubTypeData = [];
      this.selectedLocation = "";
      this.locationData = [];
      this.dateSelected = false;
      this.runDisabled = true;
      this.page = 1;
      this.totalPages = 0;
      this.showBusiness = false;
      this.showClass = false;
      this.showOEM = false;
      this.showWarehouse = false;
      this.showPOLineType = false;
      this.showStatus = false;
      this.showRouteSubType = false;
      this.showLocation = false;
      this.poStatusData = [];
      this.excelName = "";
      this.totalRecords = 0;
      this.exportDisable = true;
      this.export50kData = false;
      this.exportDialog = false;
      this.showData = false;
    },
    // set end Date
    setEndDate() {
      let minEndDate = new Date(this.sDate);
      this.minEndDate = new Date(minEndDate.getTime() + 0)
        .toISOString()
        .substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0)
        .toISOString()
        .substr(0, 10);
    },
    //On click continue
    async onContinue() {
      !this.sDate
        ? (this.sDate = new Date(new Date().getTime() - 86400000)
            .toISOString()
            .substr(0, 10))
        : "";
      let obj = {
        pass: 0,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: 0,
        part_num: '',
        bu_id: 0,
        class_id: 0,
        ware_id: 0,
        oem_id: 0,
        ordtype: '',
        cStat: ' ',
        route_sub_type: '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let projData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (projData.message !== "NA") {
        this.projectList = projData;
        this.dateSelected = true;
      } else {
        let Alert = {
          type: "error",
          isShow: true,
          message: "No Data Available change the Start Date",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.dateSelected = false;
      }
    },
    //Project Selected
    async onChangeProject() {
      let obj = {
        pass: 1,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: 0,
        class_id: 0,
        ware_id: 0,
        oem_id: 0,
        ordtype: '',
        cStat: ' ',
        route_sub_type: '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let busData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (busData.message !== "NA") {
        this.businessData = busData;
        this.runDisabled = true;
        this.showBusiness = true;
        this.showClass = false;
        this.showOEM = false;
        this.showWarehouse = false;
        this.showPOLineType = false;
        this.showStatus = false;
        this.showRouteSubType = false;
        this.showLocation = false;
        this.selectedBusiness = "";
        this.selectedClass = "";
        this.selectedOEM = "";
        this.selectedWarehouse = "";
        this.selectedPOLineType = "";
        this.selectedStatus = "";
        this.selectedRouteSubType = "";
        this.selectedLocation = "";
        this.poStatusData = [];
        this.totalRecords = 0;
        this.totalPages = 0;
        this.exportDisable = true;
        this.showData = false;
      }
    },
    //Business selected
    async businessSelected() {
      let obj = {
        pass: 2,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(this.selectedBusiness),
        class_id: 0,
        ware_id: 0,
        oem_id: 0,
        ordtype: '',
        cStat: ' ',
        route_sub_type: '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let otherData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (otherData.message !== "NA") {
        this.classData = otherData;
        this.selectedClass = "";
        this.selectedOEM = "";
        this.selectedWarehouse = "";
        this.selectedPOLineType = "";
        this.selectedStatus = "";
        this.selectedRouteSubType = "";
        this.selectedLocation = "";
        this.runDisabled = true;
        this.showClass = true;
        this.showOEM = false;
        this.showWarehouse = false;
        this.showPOLineType = false;
        this.showStatus = false;
        this.showRouteSubType = false;
        this.showLocation = false;
        this.showData = false;
      }
    },
    //Class selected
    classSelected() {
      this.selectedOEM = "";
      this.selectedWarehouse = "";
      this.selectedPOLineType = "";
      this.selectedStatus = "";
      this.selectedRouteSubType = "";
      this.selectedLocation = "";
      this.runDisabled = true;
      this.showOEM = true;
      this.showWarehouse = false;
      this.showPOLineType = false;
      this.showStatus = false;
      this.showRouteSubType = false;
      this.showLocation = false;
      this.showData = false;
      if (this.selectedClass !== 0) {
        this.OEMData = this.classData.filter(
          (obj) => obj.class_key == this.selectedClass
        );
      } else {
        this.OEMData = this.classData;
      }
    },
    //OEM Selected
    OEMSelected() {
      this.selectedWarehouse = "";
      this.selectedPOLineType = "";
      this.selectedStatus = "";
      this.selectedRouteSubType = "";
      this.selectedLocation = "";
      this.runDisabled = true;
      this.showWarehouse = true;
      this.showPOLineType = false;
      this.showStatus = false;
      this.showRouteSubType = false;
      this.showLocation = false;
      this.showData = false;
      if (this.selectedOEM !== 0) {
        this.warehouseData = this.OEMData.filter(
          (obj) => obj.oem_key == this.selectedOEM
        );
      } else {
        this.warehouseData = this.OEMData;
      }
    },
    //Warehouse Selected
    async warehouseSelected() {
      let obj = {
        pass: 3,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(this.selectedBusiness),
        class_id: parseInt(this.selectedClass),
        ware_id: parseInt(this.selectedWarehouse),
        oem_id: parseInt(this.selectedOEM),
        ordtype: this.selectedPOLineType ? this.selectedPOLineType.toString() : '',
        cStat: ' ',
        route_sub_type: '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let otherData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (otherData.message !== "NA") {
        this.poLineTypeData = otherData;
        this.selectedPOLineType = "";
        this.selectedStatus = "";
        this.selectedRouteSubType = "";
        this.selectedLocation = "";
        this.runDisabled = true;
        this.showPOLineType = true;
        this.showStatus = false;
        this.showRouteSubType = false;
        this.showLocation = false;
        this.showData = false;
      }
    },
    //PO Line Type Selected
    async POLineTypeSelected() {
      let obj = {
        pass: 4,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(this.selectedBusiness),
        class_id: parseInt(this.selectedClass),
        ware_id: parseInt(this.selectedWarehouse),
        oem_id: parseInt(this.selectedOEM),
        ordtype: this.selectedPOLineType ? this.selectedPOLineType.toString() : '',
        cStat: ' ',
        route_sub_type: '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let otherData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (otherData.message !== "NA") {
        this.statusData = otherData;
        this.selectedStatus = "";
        this.selectedRouteSubType = "";
        this.selectedLocation = "";
        this.runDisabled = true;
        this.showStatus = true;
        this.showRouteSubType = false;
        this.showLocation = false;
        this.showData = false;
      }
    },
    //Status Selected
    async statusSelected() {
      let obj = {
        pass: 5,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(this.selectedBusiness),
        class_id: parseInt(this.selectedClass),
        ware_id: parseInt(this.selectedWarehouse),
        oem_id: parseInt(this.selectedOEM),
        ordtype: this.selectedPOLineType ? this.selectedPOLineType.toString() : '',
        cStat: this.selectedStatus ? this.selectedStatus : ' ',
        route_sub_type: '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let otherData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (otherData.message !== "NA") {
        this.locationData = otherData;
        this.selectedRouteSubType = "";
        this.selectedLocation = "";
        this.runDisabled = false;
        this.showRouteSubType = false;
        this.showLocation = true;
        this.showData = false;
      }
    },
    //Route Sub Type Selected
    async routeSubTypeSelected() {
      let obj = {
        pass: 3,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(this.selectedBusiness),
        class_id: parseInt(this.selectedClass),
        ware_id: parseInt(this.selectedWarehouse),
        oem_id: parseInt(this.selectedOEM),
        ordtype: this.selectedPOLineType ? this.selectedPOLineType.toString() : '',
        cStat: this.selectedStatus ? this.selectedStatus : ' ',
        route_sub_type: this.selectedRouteSubType || '',
        location: ' ',
        PageNumber: 1,
        PageSize: 10,
      };
      let showMessage = false;
      let otherData = await reportService.purchaseOrderStatus(
        "post",
        obj,
        showMessage
      );
      if (otherData.message !== "NA") {
        this.runDisabled = true;
        this.showLocation = true;
        this.selectedLocation = "";
        this.locationData = otherData;
      }
    },
    //Run Report
    async runReport() {
      this.onClickSearch(1);
      this.page = 1;
    },
    //Run Report
    async onClickSearch(page) {
      let obj = {
        pass: 6,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(
          this.selectedBusiness == null || this.selectedBusiness == ""
            ? 0
            : this.selectedBusiness
        ),
        class_id: parseInt(
          this.selectedClass == null || this.selectedClass == ""
            ? 0
            : this.selectedClass
        ),
        oem_id: parseInt(
          this.selectedOEM == null || this.selectedOEM == ""
            ? 0
            : this.selectedOEM
        ),
        ware_id: parseInt(
          this.selectedWarehouse == null || this.selectedWarehouse == ""
            ? 0
            : this.selectedWarehouse
        ),
        ordtype: this.selectedPOLineType == 0 || this.selectedPOLineType == null || this.selectedPOLineType == ""
            ? ''
            : this.selectedPOLineType.toString(),
        cStat: this.selectedStatus == 0 || this.selectedStatus == null || this.selectedStatus == ""
            ? ''
            : this.selectedStatus,
        route_sub_type: this.selectedRouteSubType == null || this.selectedRouteSubType == ""
            ? ''
            : this.selectedRouteSubType,
        location: this.selectedLocation == 0 || this.selectedLocation == null || this.selectedLocation == ""
            ? ''
            : this.selectedLocation,
        PageNumber: page,
        PageSize: 10,
      };
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/rt/po_status_report_new", obj)
        .then((response) => {
          if (response.status == 200) {
            let responseData = response.data.body;
            this.totalRecords = responseData[0]?.TotalRecords;
            this.totalPages = responseData[0]?.TotalPages;
            if (responseData.length > 0) {
              const newArr = responseData.map((obj) => {
                return {
                  ...obj,
                  Order_Date: Utility.displayDateFormat(obj.Order_Date),
                  Req_date: Utility.displayDateFormat(obj.Req_date),
                };
              });
              this.poStatusData = newArr;
              this.exportDisable = false;
              this.showData = true;
            } else {
              this.poStatusData = [];
              this.totalRecords = 0;
              this.totalPages = 0;
              this.exportDisable = true;
              this.showData = false;
              let Alert = {
                type: "error",
                isShow: true,
                message: "No records based on the selected criteria",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Export Data using component
    async exportData() {
      this.export50kData = true;
      this.exportDialog = false;
    },
    //To export the Excel file
    async exportExcel() {
      let obj = {
        pass: 7,
        user_id: parseInt(this.userId),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        proj_id: parseInt(this.selectedProject),
        part_num: '',
        bu_id: parseInt(
          this.selectedBusiness == null || this.selectedBusiness == ""
            ? 0
            : this.selectedBusiness
        ),
        class_id: parseInt(
          this.selectedClass == null || this.selectedClass == ""
            ? 0
            : this.selectedClass
        ),
        ware_id: parseInt(
          this.selectedWarehouse == null || this.selectedWarehouse == ""
            ? 0
            : this.selectedWarehouse
        ),
        oem_id: parseInt(
          this.selectedOEM == null || this.selectedOEM == ""
            ? 0
            : this.selectedOEM
        ),
        potype_key: parseInt(
          this.selectedPOLineType == null || this.selectedPOLineType == ""
            ? 0
            : this.selectedPOLineType
        ),
        ordtype: this.selectedPOLineType == 0 || this.selectedPOLineType == null || this.selectedPOLineType == ""
          ? ''
          : this.selectedPOLineType.toString(),
        cStat: this.selectedStatus == 0 || this.selectedStatus == null || this.selectedStatus == ""
          ? ''
          : this.selectedStatus,
        route_sub_type: this.selectedRouteSubType == null || this.selectedRouteSubType == ""
          ? ''
          : this.selectedRouteSubType,
        location: this.selectedLocation == 0 || this.selectedLocation == null || this.selectedLocation == ""
          ? ''
          : this.selectedLocation,
        PageNumber: 1,
        PageSize: 10,
      };
      this.excelName =
        "Purchase_Order_Status_" +
        new Date()
          .toISOString()
          .replace("T", "_")
          .replace("Z", "")
          .replace(".", "")
          .replaceAll("-", "_") +
        ".xls";
      let response = await this.axios.post(
        "/rt/po_status_report_export",
        obj
      );
      let responseData = response?.data?.body;
      
      // Check actual response length after API call
      if (responseData && responseData.length > 50000 && !this.export50kData) {
        this.totalRecords = responseData.length;
        this.exportDialog = true;
        this.finishDownload();
        return true;
      }
      
      responseData?.forEach((element) => {
        element.Order_Date =
          element.Order_Date == ""
            ? ""
            : Utility.displayDateFormat(element.Order_Date);
        element.Req_date =
          element.Req_date == ""
            ? ""
            : Utility.displayDateFormat(element.Req_date);
      });
      this.export50kData = false;
      return responseData;
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //End the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    //To brings page based actions to the page
    actionSetter(action) {
      if (
        this.actionList !== undefined &&
        this.actionList !== null &&
        this.actionList !== ""
      ) {
        let filter = this.actionList.filter(
          (entry) => entry.SystemName === action
        );
        return filter !== undefined && filter !== null && filter.length == 1
          ? true
          : false;
      } else return false;
    },
    onClickPagination(page) {
      this.page = page;
      this.onClickSearch(page);
    },
  },
  components: {
    breadcrumbComp,
    BackToTop,
    exportLimit,
  },
};
